// extracted by mini-css-extract-plugin
export default {"form":"Fields_form__9M4c5","container":"Fields_container__ONe2v","row":"Fields_row__fbq8R","col":"Fields_col__VjrNs","btncontent":"Fields_btncontent__Xb56-"};